import type { LensProposal } from './lensProposal';

/** A candidate becomes terminal only after the server confirms it cannot be used again. */
export async function discardLensDraft(
  proposal: Pick<LensProposal, 'candidateId'>,
  discardCandidate: (body: { candidateId: string; action: 'discard' }) => Promise<{ status?: string }>,
  finish: () => void,
): Promise<void> {
  if (proposal.candidateId) {
    const response = await discardCandidate({ candidateId: proposal.candidateId, action: 'discard' });
    if (response.status !== 'discarded') throw new Error('The draft was not discarded. Try again.');
  }
  finish();
}
